import React from 'react';
import { motion } from 'framer-motion';
import { LANDING_COLORS } from './LandingConstants';

/**
 * GlowingOrb - Animated glowing orb for background effects
 * @param {number} delay - Animation delay in seconds
 * @param {number} size - Size in pixels (default: 300)
 * @param {string} color - Hex color (default: primary brand color)
 */
export default function GlowingOrb({ delay = 0, size = 300, color = LANDING_COLORS.primary }) {
  return (
    <motion.div
      className="absolute rounded-full blur-3xl"
      style={{
        width: size,
        height: size,
        background: `radial-gradient(circle, ${color}30, transparent 70%)`,
      }}
      animate={{
        scale: [1, 1.2, 1],
        opacity: [0.3, 0.6, 0.3],
      }}
      transition={{
        duration: 4,
        repeat: Infinity,
        delay,
      }}
    />
  );
}
